import React from "react";

import OptionsBox from "./options_box";

const PrefId = ({ prefs, setPrefId, prefId }) => (
  <React.Fragment>
    <h6 className="text-fw-bold text-center mb-3_5 line-height-2">
      現在のお住まいはどちらですか？
    </h6>
    <div className="" style={{ paddingTop: "30px", paddingBottom: "180px" }}>
      <ul className="nav flex-column">
        {prefs.map((pref) => (
          <OptionsBox
            key={pref.id}
            option={{ id: pref.id, option_wording: pref.name }}
            type={"radio"}
            setPrefId={(v) => setPrefId(v)}
            checked={pref.id === prefId}
          />
        ))}
      </ul>
    </div>
  </React.Fragment>
);

export default PrefId;
